import React, { ReactElement, useEffect, useState } from 'react'
import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import Container from '../components/container/Container'
import styles from './LoginLayout.module.scss'
import { fetchCustomLoginSettings, getLocales } from '../utils/HttpUrlConstants'
import { ICustomSettings } from '../utils/types'
import { localeData } from '../components/footer/Footer.types'
import Cookies from 'js-cookie'
import { useTranslation } from 'react-i18next'
import { DCONE_LOCALE_COOKIE_NAME } from '../utils/constants'

const LogInLayout = (
  {
    children
  }: React.PropsWithChildren<any>): ReactElement => {
  const { i18n } = useTranslation();
  const [customSettings, setCustomSettings] = useState<ICustomSettings>()
  const [locales, setLocales] = useState<localeData[]>()
  const [, languageCode] = useState('en-US')
  const [language, setLanguage] = useState('English')

  // update language, code and cookie on change
  const onLocaleChange = (language: string, code: string) => {
    i18n.changeLanguage(code).then(() => {
      languageCode(language)
      setLanguage(code)
      Cookies.set('lang', code.replace('-', '_'))
    })
  }

  // fetch locales and reformat response for compatibility
  useEffect(() => {
    fetch(getLocales(), {
      method: 'get'
    }).then(response => response.json())
    .then(data => {
      const localeData = data.map(locale => {
        const code = locale.code.replace('_', '-')
        return {
          key: code,
          label: locale.language,
          onClick: () => onLocaleChange(locale.language, code)
        }
      })
      setLocales(localeData)
    });
  }, [])

  // if cookie lang set use as default
  useEffect(() => {
    const langCode = Cookies.get(DCONE_LOCALE_COOKIE_NAME)
    if(locales && langCode) {
      const selectedLanguage = locales.find(locale => locale.key === langCode.replace('_', '-'))
      if (selectedLanguage) {
        i18n.changeLanguage(selectedLanguage.key.replace('_', '-')).then(()=> {
          setLanguage(selectedLanguage.label as string)
        })
      }
    }
  }, [locales, language]);

  useEffect(() => {
    fetch(fetchCustomLoginSettings()).then(response => {
      if (response.ok) {
        return response.json()
      }
    }).then((data) => {
      setCustomSettings(data)
    })
  }, [])

  if (locales && customSettings) {
    return (
      <section className={styles.loginLayout}>
        <Header logoDataUri={customSettings.logo}/>

        <Container maxWidth='450px' centered className={styles.container}>
          <div className={styles.content}>{children}</div>
        </Container>

        <Footer locales={locales} currentLanguage={language} customSettings={customSettings}/>
      </section>
    )
  }

  else return <></>
}

export default LogInLayout